import { useCallback, useSyncExternalStore } from 'react';

/** Below Tailwind `md` (768px): the phone layout (#2487). */
export const PHONE_MEDIA_QUERY = '(max-width: 767px)';

function mediaQueryList(query: string): MediaQueryList | null {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(query)
    : null;
}

/**
 * Whether `query` matches now, re-rendering the caller when that changes.
 * Without `window.matchMedia` (jsdom) it is constantly false.
 */
export function useMediaQuery(query: string): boolean {
  const subscribe = useCallback(
    (onChange: () => void) => {
      const list = mediaQueryList(query);
      if (list === null) return () => {};
      list.addEventListener('change', onChange);
      return () => list.removeEventListener('change', onChange);
    },
    [query],
  );
  const getSnapshot = () => mediaQueryList(query)?.matches ?? false;
  return useSyncExternalStore(subscribe, getSnapshot, () => false);
}

/** The phone layout switch shared by the shell and `/dispatch` (#2487 M1). */
export function useIsPhone(): boolean {
  return useMediaQuery(PHONE_MEDIA_QUERY);
}
